// eslint-disable-next-line import/prefer-default-export

export const SET_TOKEN = 'setToken';
export const SET_EXPIRESTIME = 'setExpiresTime';
export const SET_USERINFO = 'setUserInfo';
export const SET_ISRUNLOGIN = 'setIsrunlogin';
export const SET_SERCHKEY = 'setSerchkey';
export const SET_SERCHCON = 'setSerchCon';
